import { CollectionImage } from '~/components/collections';
import { StyledImgContainer } from './VehicleCardPreview.styled';

const VehicleCardPreview = ({ model }: { model: string }) => {
	return (
		<StyledImgContainer>
			<CollectionImage collection={'vehicles'} id={model} size={124} />
		</StyledImgContainer>
	);
};

export { VehicleCardPreview };
